import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AccountMenu from '../../Modules/AccountMenu'
import BekendeOpleidingNew from '../../Modules/Kennis/Toevoegen/BekendeOpleidingNew'

import RefferalSearch from '../../Modules/Kennis/Toevoegen/RefferalSearch'
import RegularSearch from '../../Modules/Kennis/Toevoegen/RegularSearch'
import Api from '../../../Global/Modules/Api';

const FETCH_URL = "api/educations/knowntraining"

class MemberCursusAdd extends Component {
	constructor(props) {
		super(props)
		this.onUpdate = this.onUpdate.bind(this)
		this.onFileUpdate = this.onFileUpdate.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.state = {
			institution: null,
			course: null,
			date: '',
			points: '',
			diploma: null,
			errors: {}
		}
	}

	onUpdate = (name, value) => {
		this.setState({
			[name]: value
		})
	}

	onFileUpdate = file => {
		this.fileInput = file
	}

	// Function that will be executed when the submit button is pressed
	handleSubmit(event) {
		event.preventDefault()
		Api.print(`Institution: ${this.state.institution}; course: ${this.state.course}; date: ${this.state.date}; points: ${this.state.points}`)

		var formData = new FormData()
		formData.append('courseId', this.state.course)
		formData.append('yearEnd', this.state.date)

		const file = this.fileInput.files[0]
		formData.append('file', file === undefined ? null : file)

		Api.print(
			`Institution: ${this.state.institution}; 
			course: ${this.state.course}; 
			date: ${this.state.date}; 
			points: ${this.state.points},
			file: ${this.fileInput.files[0]}`
		)

		Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
			.then(response => {
				if (response !== undefined)
					Api.print(response)

				else {
					alert('Education saved')
					window.location.href = '/kennis/beheren'
				}
			})
	}

	render() {
		return (
			<div className="route">
				<AccountMenu />
				<div className="grey-bg">
					<h1 className="pageTitle">
						Een opleiding toevoegen
            		</h1>
					<Form horizontal onSubmit={this.handleSubmit}>
						<Row>
							<Col md={6}>
								<h4>Zoek op referentie nummer</h4>
								<hr />
								<RefferalSearch />
							</Col>
							<Col md={6}>
								<h4>Regulier zoeken</h4>
								<hr />
								<RegularSearch type="O" onUpdate={this.onUpdate} />
							</Col>
						</Row>
						<hr />
						<Row>
							<Col mdPush={2} md={8}>
								<BekendeOpleidingNew
									onUpdate={this.onUpdate}
									onFileUpdate={this.onFileUpdate}
									points={this.state.points}
									diploma={this.state.course ? this.state.diploma : null} />
							</Col>

						</Row>
						<Row>
							<Col smOffset={8} sm={2}>
								<Button type="submit">Toevoegen</Button>
								{Api.showError(this.state.errors, "generalError")} <br /><br />
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<p><i>* Na controle van de invoer wordt het aantal punten definitief vastgesteld. Dit kan verschillen met het puntenaantal dat automatisch gegenereerd wordt. </i></p>
								<p className="text-right"><Link to="/kennis/onbekende-opleiding/toevoegen">Staat jouw opleiding er niet bij? voeg er een toe!</Link></p>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		);
	}
}

export default MemberCursusAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/Opleiding.js